import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import ProductBox from "@/src/components/ProductBox/ProductBox";
import Icon from "@/src/components/Icon/Icon";
import { Check } from "@mui/icons-material";

type MessageCompletedProps = {
  product: AbstractCase;
};

export default function MessageCompleted({ product }: MessageCompletedProps) {
  return (
    <ProductBox>
      <Stack
        spacing={4}
        sx={{
          alignItems: "center",
          textAlign: "center",
          padding: "4rem 0",
        }}
      >
        <Icon variant={"bordered"} icon={({ fill }) => <Check fontSize={"large"} sx={{ fill }} />} />
        <Typography>
          <strong>Ihre Nachricht wurde erfolgreich an unser Team versendet.</strong>
        </Typography>
        <Button fullWidth={false} component={Link} to={"/servicewelt/nachrichten?caseId=" + product.id} variant={"contained"}>
          Zurück zur Nachrichtenseite
        </Button>
      </Stack>
    </ProductBox>
  );
}
